

// import React, { useState, useEffect } from "react";
// import { Plus, Search, Trash2, Edit2 } from "lucide-react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import ApiUrl from "../Environment/ApiUrl";

// const Personal_Stock = () => {
//   const [personalStockData, setPersonalStockData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [deleteShowModal, setDeleteShowModal] = useState(false);
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [updateModal, setUpdateModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [showPersonalModal, setShowPersonalModal] = useState(false);

//   const [personalFormData, setPersonalFormData] = useState({
//     warehouse: "",
//     hsn_code: "",
//     tyre_size: "",
//     in_qty: "",
//     out_qty: "",
//     available_quantity: "",
//   });

//   const [updateData, setUpdateData] = useState({
//     warehouse: "",
//     HSN_code: "",
//     Tyre_size: "",
//     In_quantity: "",
//     out_quantity: "",
//     availabel_quantity: "",
//   });

//   // Privileges state
//   const [privileges, setPrivileges] = useState(null);

//   // Fetch privileges from localStorage
//   useEffect(() => {
//     const getaccess = localStorage.getItem("role");
//     setPrivileges(getaccess);
//   }, []);

//   // Fetch personal stock data
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(`${ApiUrl}/personal_stock.php`);
//       if (response.data && response.data.data) {
//         setPersonalStockData(response.data.data);
//       } else {
//         setPersonalStockData([]);
//         toast.error("No personal stock data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching personal stock data:", error);
//       setError("Failed to fetch personal stock data. Please try again.");
//       toast.error("Failed to fetch personal stock data.");
//       setPersonalStockData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePersonalSubmit = async (e) => {
//     e.preventDefault();
//     // Validation
//     const errors = {};
//     if (!personalFormData.warehouse) errors.warehouse = "Warehouse is required";
//     if (!personalFormData.hsn_code) errors.hsn_code = "HSN Code is required";
//     if (!personalFormData.tyre_size) errors.tyre_size = "Tyre Size is required";
//     if (!personalFormData.in_qty || isNaN(parseInt(personalFormData.in_qty)))
//       errors.in_qty = "Valid in quantity is required";
//     if (!personalFormData.out_qty || isNaN(parseInt(personalFormData.out_qty)))
//       errors.out_qty = "Valid out quantity is required";
//     if (
//       !personalFormData.available_quantity ||
//       isNaN(parseInt(personalFormData.available_quantity))
//     )
//       errors.available_quantity = "Valid available quantity is required";

//     if (Object.keys(errors).length > 0) {
//       setError(Object.values(errors).join(", "));
//       toast.error(Object.values(errors).join(", "));
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${ApiUrl}/personal_stock.php`,
//         personalFormData
//       );

//       setPersonalFormData({
//         warehouse: "",
//         hsn_code: "",
//         tyre_size: "",
//         in_qty: "",
//         out_qty: "",
//         available_quantity: "",
//       });
//       setShowPersonalModal(false);
//       toast.success(
//         response.data.message || "Personal stock item added successfully!"
//       );
//       fetchData();
//     } catch (error) {
//       console.error("Error adding personal stock:", error);
//       const errorMessage =
//         error.response?.data?.message ||
//         "Failed to add personal stock item. Please try again.";
//       setError(errorMessage);
//       toast.error(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenDeleteModal = (item) => {
//     setDeleteItem(item);
//     setDeleteShowModal(true);
//   };

//   const handleDelete = async () => {
//     try {
//       console.log("Delete data", deleteItem);
//       await axios.delete(`${ApiUrl}/personal_stock.php/${deleteItem.id}`, {
//         data: {
//           HSN_code: deleteItem.HSN_code,
//           warehouse: deleteItem.warehouse,
//           Tyre_size: deleteItem.Tyre_size,
//         },
//       });
//       setDeleteShowModal(false);
//       fetchData();
//       toast.success("Personal stock item deleted successfully!");
//     } catch (error) {
//       console.error("Error deleting personal stock:", error);
//       setError("Failed to delete personal stock item. Please try again.");
//       toast.error("Failed to delete personal stock item.");
//     }
//   };

//   const handleUpdate = (data) => {
//     setUpdateModal(true);
//     setUpdateData({
//       warehouse: data.warehouse || "",
//       HSN_code: data.HSN_code || "",
//       Tyre_size: data.Tyre_size || "",
//       In_quantity: data.In_quantity || "",
//       out_quantity: data.out_quantity || "",
//       availabel_quantity: data.availabel_quantity || "",
//       id: data.id || "",
//     });
//     console.log("update data", data);
//   };

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();

//     // Validation
//     const errors = {};
//     if (!updateData.warehouse) errors.warehouse = "Warehouse is required";
//     if (!updateData.HSN_code) errors.HSN_code = "HSN Code is required";
//     if (!updateData.Tyre_size) errors.Tyre_size = "Tyre Size is required";
//     if (!updateData.In_quantity || isNaN(parseInt(updateData.In_quantity)))
//       errors.In_quantity = "Valid In Quantity is required";
//     if (!updateData.out_quantity || isNaN(parseInt(updateData.out_quantity)))
//       errors.out_quantity = "Valid Out Quantity is required";

//     if (Object.keys(errors).length > 0) {
//       setError(Object.values(errors).join(", "));
//       toast.error(Object.values(errors).join(", "));
//       return;
//     }

//     // Prepare payload
//     const payload = {
//       warehouse: updateData.warehouse,
//       hsn_code: updateData.HSN_code,
//       tyre_size: updateData.Tyre_size,
//       in_qty: parseInt(updateData.In_quantity) || 0,
//       out_qty: parseInt(updateData.out_quantity) || 0,
//       availabel_quantity:
//         parseInt(updateData.In_quantity) - parseInt(updateData.out_quantity) ||
//         0,
//     };

//     console.log("update Data....", updateData);

//     try {
//       setLoading(true);
//       setError(null);

//       const response = await axios.put(
//         `${ApiUrl}/personal_stock.php/${updateData.id}`,
//         payload,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.data.status) {
//         throw new Error(
//           response.data.message || "Failed to update personal stock"
//         );
//       }

//       setUpdateModal(false);
//       fetchData();
//       toast.success("Personal stock updated successfully!");
//     } catch (error) {
//       console.error("Error updating personal stock:", error);
//       const errorMessage =
//         error.response?.status === 404
//           ? "Personal stock item not found"
//           : error.message || "Failed to update personal stock item";
//       setError(errorMessage);
//       toast.error(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredStocks = personalStockData.filter((stock) =>
//     Object.values(stock)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredStocks.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentStocks = filteredStocks.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   const warehouses = ["Warehouse 1", "Warehouse 2", "Warehouse 3"];

//   return (
//     <div className="bg-white font-sans">
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         closeOnClick
//         pauseOnHover
//       />
//       {error && (
//         <div className="alert alert-danger mx-3 mx-md-4 mt-3" role="alert">
//           {error}
//         </div>
//       )}

//       <div className="p-3 p-md-4 bg-white">
//         <div className="d-flex justify-content-between align-items-center">
//           <h2 className="m-0 fs-5 fw-semibold text-dark">Personal Stocks</h2>
//           <div className="d-flex justify-content-end gap-3">
//             <button
//               className="btn btn-danger d-flex align-items-center gap-2"
//               onClick={() => setShowPersonalModal(true)}
//             >
//               <Plus size={18} />
//               Add Personal Stock
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="card mx-3 mx-md-4 border">
//         <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
//           <div
//             className="d-flex align-items-center gap-2"
//             style={{ height: "36px", width: "120px" }}
//           >
//             <div
//               className="d-flex align-items-center justify-content-center"
//               style={{ height: "28px", width: "14px" }}
//             >
//               <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
//                 <rect x="1" y="1" width="3" height="3" fill="#666" />
//                 <rect x="1" y="5" width="3" height="3" fill="#666" />
//                 <rect x="1" y="9" width="3" height="2" fill="#666" />
//                 <rect x="5" y="1" width="6" height="1" fill="#666" />
//                 <rect x="5" y="3" width="6" height="1" fill="#666" />
//                 <rect x="5" y="5" width="6" height="1" fill="#666" />
//                 <rect x="5" y="7" width="6" height="1" fill="#666" />
//                 <rect x="5" y="9" width="6" height="1" fill="#666" />
//               </svg>
//             </div>
//             <select
//               className="border-0 bg-transparent text-dark form-select form-select-sm"
//               style={{
//                 boxShadow: "none",
//                 outline: "none",
//                 lineHeight: "1.1",
//                 height: "28px",
//                 cursor: "pointer",
//                 width: "80px",
//                 paddingTop: "0",
//                 paddingBottom: "0",
//               }}
//               value={itemsPerPage}
//               onChange={(e) => {
//                 setItemsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">Show 5</option>
//               <option value="10">Show 10</option>
//               <option value="25">Show 25</option>
//               <option value={filteredStocks.length}>Show All</option>
//             </select>
//           </div>
//           <div className="position-relative" style={{ width: "280px" }}>
//             <input
//               type="text"
//               placeholder="Search"
//               className="w-100 ps-3 pe-5 py-2 border rounded form-control"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <Search
//               size={18}
//               className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
//               style={{ pointerEvents: "none" }}
//             />
//           </div>
//         </div>

//         <div className="card-body p-0">
//           {loading ? (
//             <div className="text-center p-5">
//               <div className="spinner-border text-danger" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="table-responsive">
//                 <table className="table table-hover mb-0 text-center align-middle">
//                   <thead>
//                     <tr>
//                       {[
//                         "S.No",
//                         "Warehouse",
//                         "HSN Code",
//                         "Tyre Size",
//                         "In Qty",
//                         "Out Qty",
//                         "Available Qty",
//                         "Action",
//                       ].map((head, i) => (
//                         <th
//                           key={i}
//                           style={{ backgroundColor: "#d3d3d3" }}
//                           className="p-3 fw-semibold small text-center align-middle"
//                         >
//                           {head}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentStocks.length > 0 ? (
//                       currentStocks.map((item, index) => (
//                         <tr key={item.id} style={{ fontSize: "14px" }}>
//                           <td>{startIndex + index + 1}</td>
//                           <td>{item.warehouse}</td>
//                           <td>{item.HSN_code || "N/A"}</td>
//                           <td>{item.Tyre_size || "N/A"}</td>
//                           {/* Editable In Qty */}
//                           <td>
//                             <input
//                               type="number"
//                               className="form-control form-control-sm text-center mx-auto"
//                               style={{ width: "80px" }}
//                               value={item.In_quantity || 0}
//                               onChange={(e) => {
//                                 const updated = [...personalStockData];
//                                 updated[startIndex + index].In_quantity =
//                                   e.target.value;
//                                 updated[startIndex + index].availabel_quantity =
//                                   parseInt(e.target.value || 0) -
//                                   parseInt(
//                                     updated[startIndex + index].out_quantity ||
//                                       0
//                                   );
//                                 setPersonalStockData(updated);
//                               }}
//                             />
//                           </td>
//                           {/* Editable Out Qty */}
//                           <td>
//                             <input
//                               type="number"
//                               className="form-control form-control-sm text-center mx-auto"
//                               style={{ width: "80px" }}
//                               value={item.out_quantity || 0}
//                               onChange={(e) => {
//                                 const updated = [...personalStockData];
//                                 updated[startIndex + index].out_quantity =
//                                   e.target.value;
//                                 updated[startIndex + index].availabel_quantity =
//                                   parseInt(
//                                     updated[startIndex + index].In_quantity || 0
//                                   ) - parseInt(e.target.value || 0);
//                                 setPersonalStockData(updated);
//                               }}
//                             />
//                           </td>
//                           <td>{item.availabel_quantity || 0}</td>
//                           <td>
//                             <div className="d-flex justify-content-center gap-2">
//                               {(privileges === "Admin" ||
//                                 privileges === "Manager") && (
//                                 <>
//                                   <button
//                                     className="p-1 border-0 bg-transparent text-muted"
//                                     onClick={() => handleUpdate(item)}
//                                   >
//                                     <Edit2 size={16} />
//                                   </button>
//                                   <button
//                                     className="p-1 border-0 bg-transparent text-muted"
//                                     onClick={() => handleOpenDeleteModal(item)}
//                                   >
//                                     <Trash2 size={16} />
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan={8} className="text-center p-5">
//                           {searchTerm
//                             ? "No matching records found"
//                             : "No personal stock data available"}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="d-flex justify-content-between align-items-center p-3 border-top">
//                 <div className="small text-muted">
//                   Showing {startIndex + 1} to{" "}
//                   {Math.min(startIndex + itemsPerPage, filteredStocks.length)}{" "}
//                   of {filteredStocks.length} entries
//                 </div>
//                 <div className="d-flex align-items-center gap-2">
//                   <button
//                     className="btn btn-light btn-sm"
//                     disabled={currentPage === 1}
//                     onClick={() => setCurrentPage(currentPage - 1)}
//                   >
//                     <FaChevronLeft size={14} />
//                   </button>
//                   <span className="small">
//                     Page {currentPage} of {totalPages}
//                   </span>
//                   <button
//                     className="btn btn-light btn-sm"
//                     disabled={currentPage === totalPages}
//                     onClick={() => setCurrentPage(currentPage + 1)}
//                   >
//                     <FaChevronRight size={14} />
//                   </button>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Add Personal Stock Modal */}
//       <div
//         className={`modal fade ${showPersonalModal ? "show" : ""}`}
//         style={{
//           display: showPersonalModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header bg-danger text-white">
//               <h5 className="modal-title m-0 fw-semibold">
//                 Add Personal Stock
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close btn-close-white"
//                 onClick={() => setShowPersonalModal(false)}
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handlePersonalSubmit}>
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Warehouse <span className="text-danger">*</span>
//                     </label>
//                     <select
//                       className="form-control form-control-sm"
//                       value={personalFormData.warehouse}
//                       onChange={(e) =>
//                         setPersonalFormData({
//                           ...personalFormData,
//                           warehouse: e.target.value,
//                         })
//                       }
//                       required
//                     >
//                       <option value="">Select Warehouse</option>
//                       {warehouses.map((wh) => (
//                         <option key={wh} value={wh}>
//                           {wh}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       HSN Code <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={personalFormData.hsn_code}
//                       onChange={(e) =>
//                         setPersonalFormData({
//                           ...personalFormData,
//                           hsn_code: e.target.value,
//                         })
//                       }
//                       placeholder="Enter HSN Code"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Tyre Size <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={personalFormData.tyre_size}
//                       onChange={(e) =>
//                         setPersonalFormData({
//                           ...personalFormData,
//                           tyre_size: e.target.value,
//                         })
//                       }
//                       placeholder="Enter Tyre Size"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       In Quantity <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={personalFormData.in_qty}
//                       onChange={(e) =>
//                         setPersonalFormData({
//                           ...personalFormData,
//                           in_qty: e.target.value,
//                           available_quantity:
//                             parseInt(e.target.value || 0) -
//                             parseInt(personalFormData.out_qty || 0),
//                         })
//                       }
//                       placeholder="Enter In Quantity"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Out Quantity <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={personalFormData.out_qty}
//                       onChange={(e) =>
//                         setPersonalFormData({
//                           ...personalFormData,
//                           out_qty: e.target.value,
//                           available_quantity:
//                             parseInt(personalFormData.in_qty || 0) -
//                             parseInt(e.target.value || 0),
//                         })
//                       }
//                       placeholder="Enter Out Quantity"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Available Quantity
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={personalFormData.available_quantity}
//                       placeholder="Available Quantity"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="modal-footer border-top-0 pt-3">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-secondary"
//                     onClick={() => setShowPersonalModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button type="submit" className="btn btn-sm btn-primary">
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModal ? "show" : ""}`}
//         style={{
//           display: deleteShowModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-body text-center p-4">
//               <div className="mb-3">
//                 <svg
//                   width="60"
//                   height="60"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
//                     fill="#FEE2E2"
//                     stroke="#DC2626"
//                     strokeWidth="2"
//                   />
//                   <path
//                     d="M12 8V12"
//                     stroke="#DC2626"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                   <path
//                     d="M12 16H12.01"
//                     stroke="#DC2626"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                 </svg>
//               </div>
//               <h4 className="mb-3">Are you sure?</h4>
//               <p className="mb-4">
//                 This action cannot be undone. The personal stock item will be
//                 permanently deleted.
//               </p>
//               <div className="d-flex justify-content-center gap-3">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setDeleteShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Update Personal Stock Modal */}
//       <div
//         className={`modal fade ${updateModal ? "show" : ""}`}
//         style={{
//           display: updateModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header bg-danger text-white">
//               <h5 className="modal-title m-0 fw-semibold">
//                 Update Personal Stock
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close btn-close-white"
//                 onClick={() => setUpdateModal(false)}
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handleUpdateSubmit}>
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Warehouse <span className="text-danger">*</span>
//                     </label>
//                     <select
//                       className="form-control form-control-sm"
//                       value={updateData.warehouse}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           warehouse: e.target.value,
//                         })
//                       }
//                       required
//                     >
//                       <option value="">Select Warehouse</option>
//                       {warehouses.map((wh) => (
//                         <option key={wh} value={wh}>
//                           {wh}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       HSN Code <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={updateData.HSN_code}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           HSN_code: e.target.value,
//                         })
//                       }
//                       placeholder="Enter HSN Code"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Tyre Size <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={updateData.Tyre_size}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           Tyre_size: e.target.value,
//                         })
//                       }
//                       placeholder="Enter Tyre Size"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       In Quantity <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={updateData.In_quantity}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           In_quantity: e.target.value,
//                           availabel_quantity:
//                             parseInt(e.target.value || 0) -
//                             parseInt(updateData.out_quantity || 0),
//                         })
//                       }
//                       placeholder="Enter In Quantity"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Out Quantity <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={updateData.out_quantity}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           out_quantity: e.target.value,
//                           availabel_quantity:
//                             parseInt(updateData.In_quantity || 0) -
//                             parseInt(e.target.value || 0),
//                         })
//                       }
//                       placeholder="Enter Out Quantity"
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       Available Quantity
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control form-control-sm"
//                       value={updateData.availabel_quantity}
//                       placeholder="Available Quantity"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="modal-footer border-top-0 pt-3">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-secondary"
//                     onClick={() => setUpdateModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button type="submit" className="btn btn-sm btn-primary">
//                     Update
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Personal_Stock;


import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2 } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiUrl from "../Environment/ApiUrl";

const Personal_Stock = () => {
  const [personalStockData, setPersonalStockData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [updateModal, setUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showPersonalModal, setShowPersonalModal] = useState(false);

  const [personalFormData, setPersonalFormData] = useState({
    warehouse: "",
    hsn_code: "",
    tyre_size: "",
    in_qty: "",
    out_qty: "",
    available_quantity: "",
  });

  const [updateData, setUpdateData] = useState({
    warehouse: "",
    HSN_code: "",
    Tyre_size: "",
    In_quantity: "",
    out_quantity: "",
    availabel_quantity: "",
  });

  // Privileges state
  const [privileges, setPrivileges] = useState(null);

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  // Fetch personal stock data
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${ApiUrl}/personal_stock.php`);
      if (response.data && response.data.data) {
        setPersonalStockData(response.data.data);
      } else {
        setPersonalStockData([]);
        toast.error("No personal stock data found.");
      }
    } catch (error) {
      console.error("Error fetching personal stock data:", error);
      setError("Failed to fetch personal stock data. Please try again.");
      toast.error("Failed to fetch personal stock data.");
      setPersonalStockData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePersonalSubmit = async (e) => {
    e.preventDefault();
    // Validation
    const errors = {};
    if (!personalFormData.warehouse) errors.warehouse = "Warehouse is required";
    if (!personalFormData.hsn_code) errors.hsn_code = "HSN Code is required";
    if (!personalFormData.tyre_size) errors.tyre_size = "Tyre Size is required";
    if (!personalFormData.in_qty || isNaN(parseInt(personalFormData.in_qty)))
      errors.in_qty = "Valid in quantity is required";
    if (!personalFormData.out_qty || isNaN(parseInt(personalFormData.out_qty)))
      errors.out_qty = "Valid out quantity is required";
    if (
      !personalFormData.available_quantity ||
      isNaN(parseInt(personalFormData.available_quantity))
    )
      errors.available_quantity = "Valid available quantity is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      toast.error(Object.values(errors).join(", "));
      return;
    }

    try {
      const response = await axios.post(
        `${ApiUrl}/personal_stock.php`,
        personalFormData
      );

      setPersonalFormData({
        warehouse: "",
        hsn_code: "",
        tyre_size: "",
        in_qty: "",
        out_qty: "",
        available_quantity: "",
      });
      setShowPersonalModal(false);
      toast.success(
        response.data.message || "Personal stock item added successfully!"
      );
      fetchData();
    } catch (error) {
      console.error("Error adding personal stock:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to add personal stock item. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDeleteModal = (item) => {
    setDeleteItem(item);
    setDeleteShowModal(true);
  };

  const handleDelete = async () => {
    try {
      console.log("Delete data", deleteItem);
      await axios.delete(`${ApiUrl}/personal_stock.php/${deleteItem.id}`, {
        data: {
          HSN_code: deleteItem.HSN_code,
          warehouse: deleteItem.warehouse,
          Tyre_size: deleteItem.Tyre_size,
        },
      });
      setDeleteShowModal(false);
      fetchData();
      toast.success("Personal stock item deleted successfully!");
    } catch (error) {
      console.error("Error deleting personal stock:", error);
      setError("Failed to delete personal stock item. Please try again.");
      toast.error("Failed to delete personal stock item.");
    }
  };

  const handleUpdate = (data) => {
    setUpdateModal(true);
    setUpdateData({
      warehouse: data.warehouse || "",
      HSN_code: data.HSN_code || "",
      Tyre_size: data.Tyre_size || "",
      In_quantity: data.In_quantity || "",
      out_quantity: data.out_quantity || "",
      availabel_quantity: data.availabel_quantity || "",
      id: data.id || "",
    });
    console.log("update data", data);
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const errors = {};
    if (!updateData.warehouse) errors.warehouse = "Warehouse is required";
    if (!updateData.HSN_code) errors.HSN_code = "HSN Code is required";
    if (!updateData.Tyre_size) errors.Tyre_size = "Tyre Size is required";
    if (!updateData.In_quantity || isNaN(parseInt(updateData.In_quantity)))
      errors.In_quantity = "Valid In Quantity is required";
    if (!updateData.out_quantity || isNaN(parseInt(updateData.out_quantity)))
      errors.out_quantity = "Valid Out Quantity is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      toast.error(Object.values(errors).join(", "));
      return;
    }

    // Prepare payload
    const payload = {
      warehouse: updateData.warehouse,
      hsn_code: updateData.HSN_code,
      tyre_size: updateData.Tyre_size,
      in_qty: parseInt(updateData.In_quantity) || 0,
      out_qty: parseInt(updateData.out_quantity) || 0,
      availabel_quantity:
        parseInt(updateData.In_quantity) - parseInt(updateData.out_quantity) ||
        0,
    };

    console.log("update Data....", updateData);

    try {
      setLoading(true);
      setError(null);

      const response = await axios.put(
        `${ApiUrl}/personal_stock.php/${updateData.id}`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.data.status) {
        throw new Error(
          response.data.message || "Failed to update personal stock"
        );
      }

      setUpdateModal(false);
      fetchData();
      toast.success("Personal stock updated successfully!");
    } catch (error) {
      console.error("Error updating personal stock:", error);
      const errorMessage =
        error.response?.status === 404
          ? "Personal stock item not found"
          : error.message || "Failed to update personal stock item";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleIncrementInQty = async (item) => {
    const oldIn = parseInt(item.In_quantity || 0);
    const newIn = oldIn + 1;
    const newAvailable = newIn - parseInt(item.out_quantity || 0);

    // Update local state immutably
    const index = personalStockData.findIndex((i) => i.id === item.id);
    if (index === -1) return;

    const updated = [...personalStockData];
    updated[index] = {
      ...updated[index],
      In_quantity: newIn,
      availabel_quantity: newAvailable,
    };
    setPersonalStockData(updated);

    // Prepare payload
    const payload = {
      warehouse: item.warehouse,
      hsn_code: item.HSN_code,
      tyre_size: item.Tyre_size,
      in_qty: newIn,
      out_qty: parseInt(item.out_quantity || 0),
      availabel_quantity: newAvailable,
    };

    try {
      const response = await axios.put(
        `${ApiUrl}/personal_stock.php/${item.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to update");
      }
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Failed to update.");
      // Revert on error
      updated[index] = {
        ...updated[index],
        In_quantity: oldIn,
        availabel_quantity: oldIn - parseInt(item.out_quantity || 0),
      };
      setPersonalStockData([...updated]);
    }
  };

  const handleDecrementInQty = async (item) => {
    const oldIn = parseInt(item.In_quantity || 0);
    const newIn = oldIn - 1;
    const newAvailable = newIn - parseInt(item.out_quantity || 0);

    // Update local state immutably
    const index = personalStockData.findIndex((i) => i.id === item.id);
    if (index === -1) return;

    const updated = [...personalStockData];
    updated[index] = {
      ...updated[index],
      In_quantity: newIn,
      availabel_quantity: newAvailable,
    };
    setPersonalStockData(updated);

    // Prepare payload
    const payload = {
      warehouse: item.warehouse,
      hsn_code: item.HSN_code,
      tyre_size: item.Tyre_size,
      in_qty: newIn,
      out_qty: parseInt(item.out_quantity || 0),
      availabel_quantity: newAvailable,
    };

    try {
      const response = await axios.put(
        `${ApiUrl}/personal_stock.php/${item.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to update");
      }
      toast.success("Updated successfully IN Qty!");
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Failed to update.");
      // Revert on error
      updated[index] = {
        ...updated[index],
        In_quantity: oldIn,
        availabel_quantity: oldIn - parseInt(item.out_quantity || 0),
      };
      setPersonalStockData([...updated]);
    }
  };

  const handleIncrementOutQty = async (item) => {
    const oldOut = parseInt(item.out_quantity || 0);
    const newOut = oldOut + 1;
    const newAvailable = parseInt(item.In_quantity || 0) - newOut;

    // Update local state immutably
    const index = personalStockData.findIndex((i) => i.id === item.id);
    if (index === -1) return;

    const updated = [...personalStockData];
    updated[index] = {
      ...updated[index],
      out_quantity: newOut,
      availabel_quantity: newAvailable,
    };
    setPersonalStockData(updated);

    // Prepare payload
    const payload = {
      warehouse: item.warehouse,
      hsn_code: item.HSN_code,
      tyre_size: item.Tyre_size,
      in_qty: parseInt(item.In_quantity || 0),
      out_qty: newOut,
      availabel_quantity: newAvailable,
    };

    try {
      const response = await axios.put(
        `${ApiUrl}/personal_stock.php/${item.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to update");
      }
      toast.success("Updated successfully Out Qty!");
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Failed to update.");
      // Revert on error
      updated[index] = {
        ...updated[index],
        out_quantity: oldOut,
        availabel_quantity: parseInt(item.In_quantity || 0) - oldOut,
      };
      setPersonalStockData([...updated]);
    }
  };

  const handleDecrementOutQty = async (item) => {
    const oldOut = parseInt(item.out_quantity || 0);
    const newOut = oldOut - 1;
    const newAvailable = parseInt(item.In_quantity || 0) - newOut;

    // Update local state immutably
    const index = personalStockData.findIndex((i) => i.id === item.id);
    if (index === -1) return;

    const updated = [...personalStockData];
    updated[index] = {
      ...updated[index],
      out_quantity: newOut,
      availabel_quantity: newAvailable,
    };
    setPersonalStockData(updated);

    // Prepare payload
    const payload = {
      warehouse: item.warehouse,
      hsn_code: item.HSN_code,
      tyre_size: item.Tyre_size,
      in_qty: parseInt(item.In_quantity || 0),
      out_qty: newOut,
      availabel_quantity: newAvailable,
    };

    try {
      const response = await axios.put(
        `${ApiUrl}/personal_stock.php/${item.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to update");
      }
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Failed to update.");
      // Revert on error
      updated[index] = {
        ...updated[index],
        out_quantity: oldOut,
        availabel_quantity: parseInt(item.In_quantity || 0) - oldOut,
      };
      setPersonalStockData([...updated]);
    }
  };

  const filteredStocks = personalStockData.filter((stock) =>
    Object.values(stock)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStocks.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentStocks = filteredStocks.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const warehouses = ["Warehouse 1", "Warehouse 2", "Warehouse 3"];

  return (
    <div className="bg-white font-sans">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      {error && (
        <div className="alert alert-danger mx-3 mx-md-4 mt-3" role="alert">
          {error}
        </div>
      )}

      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="m-0 fs-5 fw-semibold text-dark">Personal Stocks</h2>
          <div className="d-flex justify-content-end gap-3">
            <button
              className="btn btn-danger d-flex align-items-center gap-2"
              onClick={() => setShowPersonalModal(true)}
            >
              <Plus size={18} />
              Add Personal Stock
            </button>
          </div>
        </div>
      </div>

      <div className="card mx-3 mx-md-4 border">
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          <div
            className="d-flex align-items-center gap-2"
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredStocks.length}>Show All</option>
            </select>
          </div>
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        <div className="card-body p-0">
          {loading ? (
            <div className="text-center p-5">
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-center align-middle">
                  <thead>
                    <tr>
                      {[
                        "S.No",
                        "Warehouse",
                        "HSN Code",
                        "Tyre Size",
                        "In Qty",
                        "Out Qty",
                        "Available Qty",
                        "Action",
                      ].map((head, i) => (
                        <th
                          key={i}
                          style={{ backgroundColor: "#d3d3d3" }}
                          className="p-3 fw-semibold small text-center align-middle"
                        >
                          {head}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentStocks.length > 0 ? (
                      currentStocks.map((item, index) => (
                        <tr key={item.id} style={{ fontSize: "14px" }}>
                          <td>{startIndex + index + 1}</td>
                          <td>{item.warehouse}</td>
                          <td>{item.HSN_code || "N/A"}</td>
                          <td>{item.Tyre_size || "N/A"}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleDecrementInQty(item)}
                              >
                                -
                              </button>
                              <span>{item.In_quantity || 0}</span>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleIncrementInQty(item)}
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleDecrementOutQty(item)}
                              >
                                -
                              </button>
                              <span>{item.out_quantity || 0}</span>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleIncrementOutQty(item)}
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td>{item.availabel_quantity || 0}</td>
                          <td>
                            <div className="d-flex justify-content-center gap-2">
                              {(privileges === "Admin" ||
                                privileges === "Manager") && (
                                <>
                                  <button
                                    className="p-1 border-0 bg-transparent text-muted"
                                    onClick={() => handleUpdate(item)}
                                  >
                                    <Edit2 size={16} />
                                  </button>
                                  <button
                                    className="p-1 border-0 bg-transparent text-muted"
                                    onClick={() => handleOpenDeleteModal(item)}
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center p-5">
                          {searchTerm
                            ? "No matching records found"
                            : "No personal stock data available"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center p-3 border-top">
                <div className="small text-muted">
                  Showing {startIndex + 1} to{" "}
                  {Math.min(startIndex + itemsPerPage, filteredStocks.length)}{" "}
                  of {filteredStocks.length} entries
                </div>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-light btn-sm"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    <FaChevronLeft size={14} />
                  </button>
                  <span className="small">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-light btn-sm"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    <FaChevronRight size={14} />
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add Personal Stock Modal */}
      <div
        className={`modal fade ${showPersonalModal ? "show" : ""}`}
        style={{
          display: showPersonalModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title m-0 fw-semibold">
                Add Personal Stock
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setShowPersonalModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handlePersonalSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Warehouse <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control form-control-sm"
                      value={personalFormData.warehouse}
                      onChange={(e) =>
                        setPersonalFormData({
                          ...personalFormData,
                          warehouse: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select Warehouse</option>
                      {warehouses.map((wh) => (
                        <option key={wh} value={wh}>
                          {wh}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={personalFormData.hsn_code}
                      onChange={(e) =>
                        setPersonalFormData({
                          ...personalFormData,
                          hsn_code: e.target.value,
                        })
                      }
                      placeholder="Enter HSN Code"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={personalFormData.tyre_size}
                      onChange={(e) =>
                        setPersonalFormData({
                          ...personalFormData,
                          tyre_size: e.target.value,
                        })
                      }
                      placeholder="Enter Tyre Size"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      In Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={personalFormData.in_qty}
                      onChange={(e) =>
                        setPersonalFormData({
                          ...personalFormData,
                          in_qty: e.target.value,
                          available_quantity:
                            parseInt(e.target.value || 0) -
                            parseInt(personalFormData.out_qty || 0),
                        })
                      }
                      placeholder="Enter In Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Out Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={personalFormData.out_qty}
                      onChange={(e) =>
                        setPersonalFormData({
                          ...personalFormData,
                          out_qty: e.target.value,
                          available_quantity:
                            parseInt(personalFormData.in_qty || 0) -
                            parseInt(e.target.value || 0),
                        })
                      }
                      placeholder="Enter Out Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Available Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={personalFormData.available_quantity}
                      placeholder="Available Quantity"
                      readOnly
                    />
                  </div>
                </div>
                <div className="modal-footer border-top-0 pt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => setShowPersonalModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModal ? "show" : ""}`}
        style={{
          display: deleteShowModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center p-4">
              <div className="mb-3">
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    fill="#FEE2E2"
                    stroke="#DC2626"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 8V12"
                    stroke="#DC2626"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12 16H12.01"
                    stroke="#DC2626"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <h4 className="mb-3">Are you sure?</h4>
              <p className="mb-4">
                This action cannot be undone. The personal stock item will be
                permanently deleted.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setDeleteShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Update Personal Stock Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title m-0 fw-semibold">
                Update Personal Stock
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setUpdateModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleUpdateSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Warehouse <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control form-control-sm"
                      value={updateData.warehouse}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          warehouse: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select Warehouse</option>
                      {warehouses.map((wh) => (
                        <option key={wh} value={wh}>
                          {wh}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.HSN_code}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          HSN_code: e.target.value,
                        })
                      }
                      placeholder="Enter HSN Code"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.Tyre_size}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          Tyre_size: e.target.value,
                        })
                      }
                      placeholder="Enter Tyre Size"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      In Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.In_quantity}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          In_quantity: e.target.value,
                          availabel_quantity:
                            parseInt(e.target.value || 0) -
                            parseInt(updateData.out_quantity || 0),
                        })
                      }
                      placeholder="Enter In Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Out Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.out_quantity}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          out_quantity: e.target.value,
                          availabel_quantity:
                            parseInt(updateData.In_quantity || 0) -
                            parseInt(e.target.value || 0),
                        })
                      }
                      placeholder="Enter Out Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Available Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.availabel_quantity}
                      placeholder="Available Quantity"
                      readOnly
                    />
                  </div>
                </div>
                <div className="modal-footer border-top-0 pt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => setUpdateModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personal_Stock;